import React from 'react';

import { Card } from 'react-bootstrap';
import { NavLink as Link } from 'react-router-dom';

function InfoBlock({ title, list }) {
  return (
    <Card className="product-info">
      <Card.Header>
        <Card.Title as='h2'>{title}</Card.Title>
      </Card.Header>
      <Card.Body>
        {
          list && list.map((item, index) => {
            return <div key={index} className="info-record">
              <strong><p>{item.label}</p></strong>
              {item.isLink ? <Link className='' to={`/?page=&category=${item.value ? item.value.toLowerCase() : ''}&search=`}>
                <span>{item.value}</span>
              </Link> : <span>{item.value}</span>}
              {item.list ? item.list.length !== 0 ?
                  <div>
                    {
                      item.list.map((listItem, listIndex) =>
                        //setting # as link since no link comes for now
                        // eslint-disable-next-line
                        <a key={listIndex} href="#">{listItem}
                          {(item.list.length - 1 !== listIndex) && <span>, </span>}
                        </a>
                      )
                    }
                  </div> : '-' : null
              }
            </div>
            }
          )
        }
      </Card.Body>
    </Card>
  )
}

export default InfoBlock;